import { connect } from "react-redux"
import { getRedesignedDashboardServicesDetails as getAllCustomerServices } from "actions-lib/getRedesignedDashboardServicesDetails"
import MobileHeader from "./MobileHeader"

const mapDispatchToProps = {
  getAllCustomerServices,
}

const mapStateToProps = (state) => ({
  userManageAccount: state.userManageAccount,
  myServices: state.myServices,
  siteLanguage: state.siteLanguage,
})

export default connect(mapStateToProps, mapDispatchToProps)(MobileHeader)
